/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema } from '../schema';
import { Statement, statementSchema } from './statement';

export interface Data22 {
  statement: Statement;
}

export const data22Schema: Schema<Data22> = object({
  statement: ['Statement', lazy(() => statementSchema)],
});
